import {
  Drawer,
  Stack,
  Typography,
  Button,
  useTheme,
  IconButton,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { logout } from "../../../../Store/Slices/userSlice";

export default function HamberMenu({ items, open, handleClose, token }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: "10000000",
        "& .MuiDrawer-paper": {
          width: "25vw",
          minWidth: "250px",
          maxWidth: "400px",
          bgcolor: theme.palette.background.default,
          border: "0",
          boxShadow: "0 0 20px rgba(0,0,0,0.3)",
        },
      }}
    >
      <Stack
        sx={{
          height: "100%",
          pt: "1rem",
          justifyContent: "space-between",
        }}
      >
        {/* Header Section */}
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              px: "1rem",
              pb: "1rem",
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Typography
              component="h2"
              sx={{
                color: theme.palette.primary.main,
                fontSize: "1.2rem", // سایز هدر منو کمی بزرگ‌تر شد
                fontWeight: "bold",
              }}
            >
              آدین زون
            </Typography>
            <IconButton
              onClick={handleClose}
              sx={{
                color: theme.palette.text.primary,
                "&:hover": {
                  bgcolor: theme.palette.action.hover,
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>

          {/* Menu Items Container */}
          <Stack
            sx={{
              padding: "1.2rem",
              gap: "0.85rem", // افزایش فاصله بین آیتم‌ها برای خوانایی بهتر
              // استایل‌دهی مستقیم به فونت عناصر داخل items برای بزرگ‌تر شدن متن آن‌ها
              "& a, & p, & span, & button, & div": {
                fontSize: "1.05rem !important",
              },
            }}
          >
            {items}
          </Stack>
        </Stack>

        {/* Dynamic Auth Button */}
        <Button
          onClick={() => {
            token ? dispatch(logout()) : navigate("/auth");
          }}
          variant="contained"
          startIcon={token ? <LogoutIcon /> : <LoginIcon />}
          sx={{
            bgcolor: token
              ? theme.palette.error.main
              : theme.palette.primary.main,
            color: "white",
            fontSize: "0.9rem", // سایز متن دکمه خروج/ورود نیز کمی بزرگ‌تر شد
            px: "1rem",
            py: "0.8rem",
            borderRadius: "1rem",
            fontWeight: "bold",
            margin: "1.2rem",
            flexDirection: "row-reverse",
            gap: "10px",
            "& .MuiButton-startIcon": {
              margin: 0,
            },
            "&:hover": {
              bgcolor: token
                ? theme.palette.error.dark
                : theme.palette.primary.dark,
            },
          }}
        >
          {token ? "خروج از حساب کاربری" : "ورود / ثبت نام"}
        </Button>
      </Stack>
    </Drawer>
  );
}
